module.exports = __webpack_public_path__ + "static/media/when.2dae244c.svg";